import ajax from "./ajax";

export function getFaqs() {
  return ajax(`/faqs?sort=display_order&per-page=1000`);
}
